export default "__VITE_ASSET__Cfj09RWD__"